import { showDialog } from 'vant';
import service from '@/utils/request';

const DEVICE_CACHE_KEY = 'hasBoundDevices';

// 是否已登录：与现有 localStorage.token 约定保持一致
export function isLoggedIn() {
  return !!localStorage.getItem('token');
}

// 判断当前用户是否绑定了设备
// 优先读 localStorage 缓存，缺失时回源 /api/device-binding/user/{userId} 并写回缓存
export async function getHasBoundDevices() {
  const cached = localStorage.getItem(DEVICE_CACHE_KEY);
  if (cached !== null) {
    return cached === 'true';
  }
  const userId = localStorage.getItem('userId');
  if (!userId) {
    return false;
  }
  try {
    const devices = await service.get('/api/device-binding/user/' + userId);
    const has = Array.isArray(devices) && devices.length > 0;
    localStorage.setItem(DEVICE_CACHE_KEY, has ? 'true' : 'false');
    return has;
  } catch (e) {
    // 请求失败时不缓存，下次再尝试
    return false;
  }
}

// 写入设备绑定缓存（设备列表变更时调用）
export function setHasBoundDevices(hasDevices) {
  localStorage.setItem(DEVICE_CACHE_KEY, hasDevices ? 'true' : 'false');
}

// 清除鉴权相关缓存（登出 / 401 时调用）
export function clearAuthCache() {
  localStorage.removeItem(DEVICE_CACHE_KEY);
}

// 弹出"未登录，请先登录"确认框
// 返回 Promise：已登录 -> resolve(true)；未登录确认 -> resolve(true)；取消/关闭 -> resolve(false)
export function requireLogin() {
  if (isLoggedIn()) {
    return Promise.resolve(true);
  }
  return showDialog({
    title: '提示',
    message: '您还未登录，请先登录',
    showCancelButton: true,
    confirmButtonText: '去登录',
    cancelButtonText: '取消'
  })
    .then(() => true)
    .catch(() => false);
}
export function getToken() {
  return localStorage.getItem('token');
}
